// extracted by mini-css-extract-plugin
module.exports = {"eChallanLocateWiseChallans":"_2Xw5E","eChallanLocateWiseChallansText":"_2AayQ","eChallanLocateWiseWrapper":"_3S1g_","eChallanLocateWiseCard":"_5VXrJ","viewMore":"_1CejV"};